import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import SocialBar from './components/SocialBar';
import ParticleBackground from './components/ParticleBackground';
import Home from './pages/Home';
import Hades from './pages/Hades';
import Ares from './pages/Ares';
import Despre from './pages/Despre';

// Page transition wrapper
const PageTransition = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  
  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

// Routes component with AnimatePresence
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route 
          path="/" 
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          } 
        />
        <Route 
          path="/hades" 
          element={
            <PageTransition>
              <Hades />
            </PageTransition>
          } 
        />
        <Route 
          path="/ares" 
          element={
            <PageTransition>
              <Ares />
            </PageTransition>
          } 
        />
        <Route 
          path="/despre" 
          element={
            <PageTransition>
              <Despre />
            </PageTransition>
          } 
        />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="relative min-h-screen gradient-bg">
        {/* Particle Background */}
        <ParticleBackground />
        
        {/* Social Bar */}
        <SocialBar />
        
        {/* Header */}
        <Header />
        
        {/* Main Content */}
        <main className="relative z-10">
          <AnimatedRoutes />
        </main>
        
        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
